import { useEffect } from 'react';
import { isITPSupported } from 'common/utilities/FlightSetting';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { getBreaches, getBreachStateCounts } from '../breachSelectors';
import { getSelectedFamilyMemberSummary } from '../identityMonitoringSelectors';
import { getBreachesAsync } from '../identityMonitoringSlice';

import { useIdentityOnboardingStatus } from './useIdentityOnboardingStatus';

/**
 * Helper hook for getting breaches
 *
 * @param root0
 * @param root0.shouldLoad
 */
export const useBreaches = ({ shouldLoad }: { shouldLoad: boolean } = { shouldLoad: true }) => {
  const dispatch = useAppDispatch();

  const { csid, isCurrentUser } = useAppSelector((state) => state.identityMonitoring.userContext);
  const { allBreaches, normalBreaches, otherBreaches, completedBreaches, getBreachesApiStatus } = useAppSelector(
    ({ identityMonitoring }) => getBreaches(identityMonitoring, csid)
  );
  const breachStateCounts = useAppSelector(({ identityMonitoring }) => getBreachStateCounts(identityMonitoring, csid));
  const selectedFamilyMemberSummary = useAppSelector((state) => getSelectedFamilyMemberSummary(state.identityMonitoring));
  const { itmOnboarded } = useIdentityOnboardingStatus();

  let hasReadPermission = isCurrentUser;
  if (!isCurrentUser && selectedFamilyMemberSummary?.itpFamilyPermissions) {
    hasReadPermission = selectedFamilyMemberSummary.itpFamilyPermissions?.value === 'SEE_MY_ALERTS_AND_ADD_INFO';
  }

  const shouldLoadBreaches = !!csid && isITPSupported() && itmOnboarded && hasReadPermission && shouldLoad;

  useEffect(() => {
    if (shouldLoadBreaches) {
      dispatch(getBreachesAsync({ csid }));
    }
  }, [dispatch, csid, shouldLoadBreaches]);

  return { allBreaches, normalBreaches, otherBreaches, completedBreaches, breachStateCounts, getBreachesApiStatus };
};
